import React from 'react';


interface Client {
  id: number;
  name: string;
  logo: string;
  alt: string;
}

const ClientLogos = () => {
  const clients: Client[] = [
  {
    id: 1,
    name: "TechCorp Global",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_197b226e6-1764677656627.png",
    alt: "TechCorp Global company logo with blue geometric design"
  },
  {
    id: 2,
    name: "FinanceHub",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1353487bb-1764664281630.png",
    alt: "FinanceHub logo featuring modern typography and gold accent"
  },
  {
    id: 3,
    name: "HealthCare Plus",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_146ed6590-1764664281973.png",
    alt: "HealthCare Plus medical services logo with green cross symbol"
  },
  {
    id: 4,
    name: "RetailMax",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1ab970bcb-1764663148981.png",
    alt: "RetailMax shopping brand logo with orange shopping cart icon"
  },
  {
    id: 5,
    name: "EduTech Solutions",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_12656db8f-1764671099325.png",
    alt: "EduTech Solutions education technology logo with book symbol"
  },
  {
    id: 6,
    name: "AutoDrive Inc",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1249838ef-1766590113156.png",
    alt: "AutoDrive Inc automotive company logo with sleek car silhouette"
  }];


  return;




































};

export default ClientLogos;